import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CreateResponse, CreateTeamBody } from '@core-http';
import { CreateTeamCommandPayload } from './create-team.command-payload';
import { CreateTeamCommandResult } from './create-team.command-result';

export class CreateTeamCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  create(payload: CreateTeamCommandPayload): Observable<CreateTeamCommandResult> {
    const requestBody: CreateTeamBody = { teamName: payload.teamName };

    return this.teamsService.createTeam(requestBody).pipe(map((dto: CreateResponse) => this.mapToResult(dto)));
  }

  private mapToResult(dto: CreateResponse): CreateTeamCommandResult {
    return {
      teamId: dto.teamId,
      teamName: dto.teamName,
      invitationToken: dto.invitationToken ?? ''
    };
  }
}
